import { shopFaqs, shopItems } from './data';
import { GetShopFAQItemsResponse, GetShopItemsResponse } from './types';

const getShopFAQs = async (): Promise<GetShopFAQItemsResponse> => Promise.resolve({ faqs: shopFaqs });

const getShopItems = async (): Promise<GetShopItemsResponse> => Promise.resolve({ items: shopItems });

export { getShopFAQs, getShopItems };
